var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg791X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "130px",
    viewBox: "0 0 160 130",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "79@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Attitude-to-goals/4",
    transform: "translate(-108.000000, -142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 79,
    transform: "translate(108.000000, 142.000000)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(51.000000, 13.629032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.352625, 26.446859)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#CAC2BB",
    cx: 28.9152322,
    cy: 31.0537309,
    rx: 28.5626074,
    ry: 27.7265454
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9152322,2.95749818 C44.8788703,2.95749818 57.8304644,15.5299836 57.8304644,31.0537309 C57.8304644,46.5774783 44.8788703,59.1499636 28.9152322,59.1499636 C12.9515942,59.1499636 0,46.5774783 0,31.0537309 C0,15.5299836 12.9515942,2.95749818 28.9152322,2.95749818 Z M28.9152322,3.69687273 C13.3294853,3.69687273 0.705249566,15.9515818 0.705249566,31.0537309 C0.705249566,46.15588 13.3294853,58.4105891 28.9152322,58.4105891 C44.5009792,58.4105891 57.1252149,46.15588 57.1252149,31.0537309 C57.1252149,15.9515818 44.5009792,3.69687273 28.9152322,3.69687273 Z",
    id: "Oval",
    fill: "#CAC2BB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 28.9152322,
    cy: 28.0962327,
    rx: 28.5626074,
    ry: 27.7265454
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9152322,0 C44.8788703,0 57.8304644,12.5724854 57.8304644,28.0962327 C57.8304644,43.6199801 44.8788703,56.1924654 28.9152322,56.1924654 C12.9515942,56.1924654 0,43.6199801 0,28.0962327 C0,12.5724854 12.9515942,0 28.9152322,0 Z M28.9152322,0.739374545 C13.3294853,0.739374545 0.705249566,12.9940836 0.705249566,28.0962327 C0.705249566,43.1983818 13.3294853,55.4530909 28.9152322,55.4530909 C44.5009792,55.4530909 57.1252149,43.1983818 57.1252149,28.0962327 C57.1252149,12.9940836 44.5009792,0.739374545 28.9152322,0.739374545 Z",
    id: "Oval",
    fill: "#CAC2BB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F88184",
    cx: 28.9152322,
    cy: 27.3568582,
    rx: 23.6258605,
    ry: 22.934303
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 28.9152322,
    cy: 26.6174836,
    rx: 17.9838639,
    ry: 17.4574545
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F88184",
    cx: 28.9152322,
    cy: 26.3436412,
    rx: 13.047117,
    ry: 12.6652121
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 28.9152322,
    cy: 25.7685721,
    rx: 7.40512045,
    ry: 7.18836363
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F88184",
    cx: 28.9152322,
    cy: 25.5221139,
    rx: 3.17362305,
    ry: 3.08072727
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-52",
    fillOpacity: 0.115464537,
    fill: "#8D6C56",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(80.500000, 23.588710) scale(1, -1) translate(-80.500000, -23.588710) ",
    points: "126 47.1774194 35 47.1774194 80 4.19019658e-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-52",
    fillOpacity: 0.115464537,
    fill: "#8D6C56",
    style: {
      mixBlendMode: "multiply"
    },
    points: "126 130 35 130 80 82.8225806"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-52",
    fillOpacity: 0.115464537,
    fill: "#8D6C56",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(137.500000, 65.524194) scale(1, -1) rotate(-90.000000) translate(-137.500000, -65.524194) ",
    points: "185.201613 88.0241935 89.7983871 88.0241935 136.975806 43.0241935"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-52",
    fillOpacity: 0.115464537,
    fill: "#8D6C56",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(22.500000, 65.524194) scale(-1, -1) rotate(-90.000000) translate(-22.500000, -65.524194) ",
    points: "70.2016129 88.0241935 -25.2016129 88.0241935 21.9758065 43.0241935"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg791X);
export default __webpack_public_path__ + "static/media/79@1x.049154d8.svg";
export { ForwardRef as ReactComponent };